import React, {Fragment, useState} from "react";
import classes from "./whatsapp.module.css";
import whatsappIcon from "../../../assets/whatsapp_logo.svg";
import {IoClose} from "react-icons/io5";
import Step1 from "./Step1";
import {Button} from "@mui/material";
import Step2 from "./Step2";
import Step3 from "./Step3";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Step4 from "./Step4";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../../api";

dayjs.extend(customParseFormat);

const HomeScreen = ({closeModal, productID, productName}) => {
  const [step, setStep] = useState(1);
  const [name, setName] = useState();
  const [mobileNo, setMobileNo] = useState();
  const [language, setLanguage] = useState("English");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [morningTimeSelected, setMorningTimeSelected] = useState();
  const [afternoonTimeSelected, setAfternoonTimeSelected] = useState();
  const [eveningTimeSelected, setEveningTimeSelected] = useState();
  const [errorMsgs, setErrMsgs] = useState([]);
  const [submissionLoader, setSubmissionLoader] = useState(false);
  const [reminderSubmitFailed, setReminderSubmitFailed] = useState(false);

  const reset = () => {
    setName();
    setMobileNo();
    setStartDate(null);
    setEndDate(null);
    setMorningTimeSelected();
    setAfternoonTimeSelected();
    setEveningTimeSelected();
    setErrMsgs([]);
    setReminderSubmitFailed(false);
    setStep(1);
  };
  const onProceed = () => {
    if (step === 1) {
      const msgs = [];
      if (!name?.length) {
        msgs.push({input: "name", msg: "Enter valid name!"});
      }

      if (mobileNo?.length !== 10) {
        msgs.push({input: "mobileNo", msg: "Enter valid mobile number!"});
      }

      if (!startDate || !endDate) {
        msgs.push({input: "date", msg: "Enter valid date range!"});
      }

      setErrMsgs(msgs);

      if (!msgs.length) {
        setStep(2);
      }
    } else if (step === 2) {
      if (!morningTimeSelected && !afternoonTimeSelected && !eveningTimeSelected) {
        setErrMsgs([{input: "reminder", msg: "Select reminder timings!"}]);
      } else {
        setErrMsgs([]);
        setStep(3);
      }
    }
  };

  const calculateDayDiff = (start, end) => {
    if (start && end) {
      const diff = end.diff(start, "day");
      return diff >= 0 ? diff + 1 : 0;
    } else {
      return 0;
    }
  };

  function convertTo24Hour(time12h) {
    const match = time12h.match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)$/i);
    if (!match) return "Invalid time";

    let hour = parseInt(match[1], 10);
    const minutes = match[2] || "00";
    const meridiem = match[3].toLowerCase();

    if (meridiem === "pm" && hour !== 12) hour += 12;
    if (meridiem === "am" && hour === 12) hour = 0;

    return hour.toString().padStart(2, "0") + ":" + minutes;
  }

  const submitReminder = async () => {
    setSubmissionLoader(true);
    setReminderSubmitFailed(false);
    const fromDate = dayjs(startDate);
    const body = {
      name: name,
      mobileNo: mobileNo,
      language: language,
      startDate: fromDate.format("YYYY/MM/DD"),
      time1: morningTimeSelected?.length ? convertTo24Hour(`${morningTimeSelected}am`) : "",
      time2: afternoonTimeSelected?.length ? convertTo24Hour(`${afternoonTimeSelected}pm`) : "",
      time3: eveningTimeSelected?.length ? convertTo24Hour(`${eveningTimeSelected}pm`) : "",
      count: calculateDayDiff(startDate, endDate),
      productName,
      productID,
    };

    try {
      await api.post("/sheets/whatsapp/addReminder", body);
      setStep(4);
      setSubmissionLoader(false);
    } catch (error) {
      setReminderSubmitFailed(true);
      setSubmissionLoader(false);
    }
  };
  return (
    <div className={classes.whatsAppHomeScreen}>
      <div className={classes.header}>
        <div className={classes.header_title_bar}>
          <div>
            <img src={whatsappIcon} alt="VerifySVG" />
            WhatsApp Reminder
          </div>
          <div
            onClick={() => {
              reset();
              closeModal();
            }}>
            <IoClose />
          </div>
        </div>

        {step !== 4 && (
          <div className={classes.headerStepper}>
            <div className={`${classes.step} ${step === 1 && classes.activeStep}`}>
              Step <div className={classes.stepCount}>1</div>
            </div>
            <div className={classes.stepConnecter}>
              <hr />
            </div>
            <div className={`${classes.step} ${step === 2 && classes.activeStep}`}>
              Step <div className={classes.stepCount}>2</div>
            </div>
            <div className={classes.stepConnecter}>
              <hr />
            </div>
            <div className={`${classes.step} ${step === 3 && classes.activeStep}`}>
              Step <div className={classes.stepCount}>3</div>
            </div>
          </div>
        )}
      </div>
      <div className={classes.stepperContent}>
        {step === 1 && <Step1 setName={setName} setMobileNo={setMobileNo} setLanguage={setLanguage} language={language} setStartDate={setStartDate} setEndDate={setEndDate} startDate={startDate} endDate={endDate} errorMsgs={errorMsgs} />}
        {step === 2 && <Step2 errorMsgs={errorMsgs} morningTimeSelected={morningTimeSelected} afternoonTimeSelected={afternoonTimeSelected} eveningTimeSelected={eveningTimeSelected} setMorningTimeSelected={setMorningTimeSelected} setAfternoonTimeSelected={setAfternoonTimeSelected} setEveningTimeSelected={setEveningTimeSelected} />}
        {step === 3 && <Step3 name={name} language={language} mobileNo={mobileNo} startDate={startDate} endDate={endDate} morningTimeSelected={morningTimeSelected} afternoonTimeSelected={afternoonTimeSelected} eveningTimeSelected={eveningTimeSelected} />}
        {step === 4 && <Step4 />}
      </div>

      {reminderSubmitFailed && <div className={`${classes.errorMessage} text_center`}>Reminder subsmission failed, Please try again later.</div>}

      <div className={classes.footer}>
        {step === 4 ? (
          <div className={classes.step4_footer}>
            <div className={classes.step4_footer_title}>What happens next?</div>
            <div className={classes.step4_footer_body}>
              <div className={classes.step4_footer_body_content}>
                <div className={classes.setp4_footer_content_sno}>1</div>
                <div>You'll receive a WhatsApp message to confirm your subscription.</div>
              </div>
              {/* <div className={classes.step4_footer_body_content}>
                <div className={classes.setp4_footer_content_sno}>2</div>
                <div>Reply with "YES" to start receiving your medicine reminders.</div>
              </div> */}
              <div className={classes.step4_footer_body_content}>
                <div className={classes.setp4_footer_content_sno}>3</div>
                <div>You'll receive a WhatsApp message to confirm your subscription.</div>
              </div>
            </div>
            <div className={classes.step4_footer_buttons}>
              <Button className={classes.goBackButton} variant="contained" onClick={() => reset()}>
                Set Another Reminder
              </Button>
              <Button
                variant="contained"
                className={classes.backHomeBtn}
                onClick={() => {
                  reset();
                  closeModal();
                }}>
                Back Home
              </Button>
            </div>
          </div>
        ) : (
          <Fragment>
            <div>Step {step}/3</div>
            <div>
              {step > 1 && (
                <Button className={classes.goBackButton} variant="contained" onClick={() => setStep(step - 1)}>
                  Go Back
                </Button>
              )}

              {step < 3 && (
                <Button variant="contained" className={classes.proceedBtn} onClick={() => onProceed()}>
                  Proceed
                </Button>
              )}

              {step === 3 && (
                <Button disabled={submissionLoader} variant="contained" className={classes.proceedBtn} onClick={() => submitReminder()}>
                  {submissionLoader ? <div className={classes.loadingButton}>Loading &nbsp;&nbsp; {<CircularProgress style={{color: "white"}} size="20px" />}</div> : "Confirm"}
                </Button>
              )}
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
};

export default HomeScreen;
